export default __webpack_public_path__ + "static/media/FilterProducts.538a4339.png";